module.exports = ":host {\n  display:block;\n}\n\nnav {\n  position:fixed;\n  top:0;\n  right:0;\n  left:0;\n  background:rgba(0,0,0,0.2);\n  z-index:10000;\n  -webkit-transition:0.5s ease-out;\n  transition:0.5s ease-out;\n  opacity:0;\n  padding:10px 2rem 10px 0;\n}\n\n.slide-controls {\n  float:right;\n}\n\nnav:hover {\n  opacity:1;\n}\n\nbutton {\n  padding:10px 15px;\n  border:0;\n  cursor:pointer;\n  outline:0;\n  background:#333;\n  color:white;\n  -webkit-transition:300ms ease-out;\n  transition:300ms ease-out;\n}\n\nbutton:hover {\n  background:#222;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main